export default "__VITE_ASSET__baaf44c0__"